import theme from '@styles/theme';
import { tabMenuType, HeaderType, CustomSelectOptionType } from '@utils/types';

// 다음 Post API 새창 option
export const postcodeOptions = {
    width: 500,
    height: 600,
    left: window.screen.width / 2 - 500 / 2,
    top: window.screen.height / 2 - 600 / 2
};
// 브이월드 2D 데이터 API default params
export const sidoParams = {
    key: 'DEFDB589-47C5-316E-A688-7B3863AC134C',
    domain: 'http://localhost:3000/',
    service: 'data',
    version: '2.0',
    request: 'getfeature',
    format: 'json',
    size: '1000',
    page: '1',
    geometry: 'false',
    attribute: 'true',
    crs: 'EPSG:4326',
    geomfilter:
        'BOX(122.77143441739624,  32.689674111652815,  133.16466627619113,  42.0516845871052)',
    data: 'LT_C_ADSIDO_INFO'
};
export const regionOptions = [
    '서울특별시',
    '부산광역시',
    '인천광역시',
    '대구광역시',
    '대전광역시',
    '광주광역시',
    '울산광역시',
    '세종특별자치시',
    '경기도',
    '충청북도',
    '충청남도',
    '전라남도',
    '경상북도',
    '경상남도',
    '강원특별자치도',
    '제주특별자치도',
    '전북특별자치도'
];
export const medicalDepartmentOptions = [
    { title: '전체', value: 0 },
    { title: '내과', value: 1 },
    { title: '정형외과', value: 2 },
    { title: '일반과', value: 3 },
    { title: '정신건강의학과', value: 4 },
    { title: '산부인과', value: 5 },
    { title: '가정의학과', value: 6 },
    { title: '외과', value: 7 },
    { title: '비뇨기과', value: 8 },
    { title: '이비인후과', value: 9 },
    { title: '소아청소년과', value: 10 },
    { title: '마취통증의학과', value: 11 },
    { title: '피부과', value: 12 },
    { title: '신경과', value: 13 },
    { title: '신경외과', value: 14 },
    { title: '재활의학과', value: 15 },
    { title: '성형외과', value: 16 },
    { title: '영상의학과', value: 17 },
    { title: '안과', value: 18 },
    { title: '치과', value: 19 },
    { title: '흉부외과', value: 20 },
    { title: '진단검사의학과', value: 21 },
    { title: '응급의학과', value: 22 },
    { title: '한방내과', value: 23 },
    { title: '요양병원', value: 24 }
];
////////////////////// 네비게이션 //////////////////////
// 헤더
export const headerTabMenu: tabMenuType[] = [
    { dataText: '보유장비', pathname: '/main' },
    { dataText: '자주하는질문', pathname: '/faq' },
    { dataText: '공지사항', pathname: '/notice' },
    { dataText: '내프로필', pathname: '/profile' }
];

export const didPointColorOptions: CustomSelectOptionType[] = [
    { label: '블루', value: theme.colors.positiveBlue },
    { label: '오렌지', value: theme.colors.activeOrange },
    { label: '핑크', value: theme.colors.pointPink },
    { label: '그린', value: theme.colors.pointGreen },
    { label: '레드', value: theme.colors.pointRed }
];
////////////////////// 테이블 헤더 //////////////////////
// 보유장비 > 내 보유 장비 현황
export const possessedEquipmentHeader: HeaderType[] = [
    { label: '순서', minWidth: 60, width: 6 },
    { label: '보유 장비명', minWidth: 467, width: 49 },
    { label: '원내 위치', minWidth: 116, width: 12 },
    { label: '설치 버전', minWidth: 86, width: 9 },
    { label: '설치일자', minWidth: 114, width: 12 },
    { label: '설치기간', minWidth: 112, width: 12 }
];
// 보유장비 > 내 보유 장비 >상세 > 플레이리스트
export const playlistHeader: HeaderType[] = [
    { label: '썸네일', minWidth: 88, width: 14 },
    { label: '파일명', minWidth: 286, width: 46 },
    { label: '유형', minWidth: 114, width: 18 },
    { label: '용량(MB)', minWidth: 134, width: 22 }
];
// 보유장비 > 내 보유 장비 >상세 > 로그
export const logHeader: HeaderType[] = [
    { label: '발생일시', minWidth: 148, width: 16 },
    { label: '내용', minWidth: 673, width: 70 },
    { label: '일일누적횟수', minWidth: 134, width: 14 }
];
// DID 모니터 설정 변경 > 플레이리스트
export const selectedPlaylistHeader: HeaderType[] = [
    { label: '#', minWidth: 75, width: 12 },
    { label: '파일명', minWidth: 307, width: 49 },
    { label: '용량(MB)', minWidth: 108, width: 17 },
    { label: '유형', minWidth: 140, width: 22 }
];
// DID 모니터 설정 변경 > 이미지 / 영상 설정
export const mediaListHeader: HeaderType[] = [
    { label: '파일명', minWidth: 404, width: 64 },
    { label: '', minWidth: 166, width: 26 },
    { label: '', minWidth: 60, width: 10 }
];
// DID 모니터 설정 변경 > 공지사항 설정
export const noticeListHeader: HeaderType[] = [
    { label: '', minWidth: 84, width: 26 },
    { label: '공지사항', minWidth: 320, width: 64 },
    { label: '', minWidth: 166, width: 26 },
    { label: '', minWidth: 60, width: 10 }
];
// 광고현황 > 내 광고 현황
export const advertisementStatusHeader: HeaderType[] = [
    { label: '순서', minWidth: 60, width: 6 },
    { label: '캠페인 제목', minWidth: 445, width: 47 },
    { label: '상태', minWidth: 116, width: 12 },
    { label: '길이', minWidth: 86, width: 9 },
    { label: '시작일자', minWidth: 114, width: 12 },
    { label: '종료일자', minWidth: 134, width: 14 }
];
